import { Controller } from 'stimulus'

export default class extends Controller {

    static targets = [
        'thumbnailPresentation',
        'thumbnailEditor',
    ]

    static values = {
        context: String
    }

    connect() {
    }

    toggleThumbnailEditor() {
        // Toggles between showing the thumbnail (or empty thumbnail if none exists yet) and the thumbnail uploader form
        if (this.hasThumbnailPresentationTarget && this.thumbnailPresentationTarget.classList.contains("hidden")) {
            this.thumbnailPresentationTarget.classList.remove("hidden");
            this.thumbnailEditorTarget.classList.add("hidden");
        } else {
            if (this.hasThumbnailPresentationTarget) this.thumbnailPresentationTarget.classList.add("hidden");
            this.thumbnailEditorTarget.classList.remove("hidden");
        }
    }
}